import { Link, useLocation, useNavigate, useSearchParams } from "react-router";
import { ArrowLeft, X } from "lucide-react";
import { getReturnLabel, getReturnTarget } from "../../utils/navigationReturn";

const defaultClassName =
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-primary/20 bg-transparent px-4 py-2 text-sm font-bold text-primary transition-all duration-200 ease-out hover:border-primary/35 hover:bg-primary/5";

export default function BackNavLink({
  fallback,
  fallbackLabel = "Back",
  className = defaultClassName,
  iconClassName = "h-4 w-4",
  children,
}) {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const to = getReturnTarget(searchParams, fallback, location.state);
  const hasReturn = Boolean(location.state?.from || searchParams.get("from"));
  const label = hasReturn ? `Back to ${getReturnLabel(to)}` : fallbackLabel;

  if (hasReturn) {
    return (
      <Link to={to} className={className}>
        <ArrowLeft className={iconClassName} />
        {children ?? label}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        if (typeof window !== "undefined" && window.history.length > 1) {
          navigate(-1);
          return;
        }
        navigate(to);
      }}
    >
      <ArrowLeft className={iconClassName} />
      {children ?? label}
    </button>
  );
}

export function FilterDismissLink({
  fallback,
  fallbackLabel = "Clear filter",
  compactLabel,
  className = "inline-flex items-center gap-1.5 rounded-lg bg-white px-3 py-1.5 text-xs font-semibold text-primary/70 ring-1 ring-primary/10 transition-colors hover:text-primary",
}) {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const to = getReturnTarget(searchParams, fallback, location.state);
  const hasReturn = Boolean(location.state?.from || searchParams.get("from"));
  const label = hasReturn
    ? compactLabel ?? `Back to ${getReturnLabel(to)}`
    : fallbackLabel;

  return (
    <Link to={to} className={className}>
      {hasReturn ? <ArrowLeft className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5" />}
      {label}
    </Link>
  );
}
